import { UzBadge } from '@utazzo/ui';

interface LegacyBadgeProps {
  /** Numeric legacy primary key from the source system, or null/undefined for new rows. */
  legacyId: number | null | undefined;
  /** Optional override label - defaults to "Legacy". */
  label?: string;
}

/**
 * Visual marker for rows that originated in the legacy .NET / MS SQL system and
 * were ETL'd into the new schema. Used across every list page where mixed
 * provenance matters (Leads, Customers, Itineraries, Bookings, Masters).
 *
 * Renders a small subtle "Legacy" pill when `legacyId != null`, nothing
 * otherwise. The pill carries a `title` attribute with the numeric source id
 * so support engineers can correlate to the source DB.
 *
 * See migration plan `docs/migration/cozy-weaving-barto.md` §C2 - shared
 * component, Stream A builds, Stream B imports.
 */
export const LegacyBadge = ({ legacyId, label = 'Legacy' }: LegacyBadgeProps) => {
  if (legacyId === null || legacyId === undefined) return null;
  return (
    <UzBadge tone="secondary" pill title={`Imported from legacy id ${legacyId}`}>
      {label}
    </UzBadge>
  );
};
